import { useTranslation } from "react-i18next";

import { Toggle } from "~/ui";
import { SearchInput } from "~/ui/SearchInput";

export type ToggleOptions = readonly [
  {
    label: string;
    value: "active";
  },
  {
    label: string;
    value: "pending";
  },
];

export const PatientTableFilters = ({
  userType,
  setUserType,
  setSearchText,
}: {
  userType: ToggleOptions[number]["value"];
  setUserType: (val: ToggleOptions[number]["value"]) => void;
  setSearchText: (val: string) => void;
}) => {
  const { t } = useTranslation();

  const TOGGLE_OPTIONS: ToggleOptions = [
    {
      label: t("patients.toggle.active_users"),
      value: "active",
    },
    {
      label: t("patients.toggle.pending_users"),
      value: "pending",
    },
  ] as const;

  return (
    <div className="mb-4 flex w-full flex-row items-center justify-between gap-3">
      <Toggle
        options={TOGGLE_OPTIONS}
        value={userType}
        onClick={(val) => setUserType(val)}
      />
      <SearchInput
        placeholder={
          userType === "active"
            ? t("patients.search_by_name_placeholder")
            : t("patients.search_by_email_placeholder")
        }
        onValueChange={setSearchText}
      />
    </div>
  );
};
